<template>
  <div>
    <hero-bar>
      Find Load
    </hero-bar>
    <section class="section is-main-section">
      <div
        class="column is-mobile is-multiline is-one-quarter"
        style="margin-top:2%;"
      >
        <b-field label="Load Name" custom-class="labelRequest" horizontal>
          <b-input id="search" v-model="searchName" />
        </b-field>
      </div>
      <div class="column is-mobile is-multiline is-one-quarter">
        <b-field label="Charge To" custom-class="labelRequest" horizontal>
          <b-select
            style="width:95%"
            placeholder="Select client"
            v-model="clientCode"
            id="client"
          >
            <option
              v-for="(client, index) in clients"
              :key="index"
              :value="{
                ccode: client.clientCode,
                acode: client.accountCode,
                cname: client.clientName
              }"
            >
              {{
                client.accountCode +
                  ":" +
                  client.clientName +
                  " (" +
                  client.clientCode +
                  ")"
              }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-mobile is-multiline is-one-quarter">
        <b-field
          label="Requested Pickup"
          custom-class="labelRequest"
          horizontal
        >
          <b-datepicker
            rounded
            placeholder="Click to select..."
            icon="calendar-today"
            v-model="searchDate"
            locale="locale"
            required
          >
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-mobile is-multiline is-one-quarter">
        <b-button type="is-primary is-outlined" @click="doSearch"
          >Search</b-button
        >&nbsp;&nbsp;
        <b-button type="is-primary is-outlined" @click="reset">Reset</b-button>
      </div>
      <div
        class="column is-one-half"
        style="margin:2%;margin-top:2%;"
        v-if="isEnabled"
      >
        <b-table
          :data="results"
          :columns="columns"
          @click="selectLoad"
          :header-checkable="false"
          :paginated="isPaginated"
          :per-page="perPage"
        >
        </b-table>
      </div>
      <div
        class="column is-one-half"
        style="margin:2%;margin-top:2%;"
        v-if="isNoResults"
      >
        No Search results
      </div>
    </section>
  </div>
</template>

<script>
import HeroBar from "@/components/HeroBar";
import axios from "axios";

export default {
  name: "Forms",
  components: { HeroBar },
  props: {
    id: {
      default: null
    }
  },
  data() {
    return {
      data: [],
      loads: [],
      loadSearch: [],
      results: [],
      isEnabled: false,
      isNoResults: false,
      searchDate: null,
      clientCode: null,
      searchName: null,
      clients: [],
      locale: "en-GB",
      isPaginated: true,
      perPage: 10,
      status: [
        { id: 1, name: "Pending" },
        { id: 2, name: "Booked" },
        { id: 3, name: "In Transit" },
        { id: 4, name: "Delivered" },
        { id: 5, name: "Complete" }
      ],
      columns: [
        { field: "date", label: "Scheduled", width: "40", searchable: true },
        { field: "load", label: "Load", width: "80", searchable: true },
        { field: "status", label: "Status", width: "40", searchable: true },
        { field: "client", label: "Charge To", width: "120", searchable: true },
        {
          field: "rdate",
          label: "Requested Pickup",
          width: "120",
          searchable: true
        },
        { field: "driver", label: "Driver", width: "60" },
        { field: "truck", label: "Truck", width: "60" },
        { field: "origin", label: "Pickup", width: "120" },
        { field: "dest", label: "Destination", width: "120" },
        { field: "id", label: "", visible: false }
      ]
    };
  },
  methods: {
    doSearch() {
      this.loadSearch = this.loads;
      this.results = [];
      if (this.searchDate !== null) {
        var scheduledDate = new Date(this.searchDate);
        var sdate = "";
        const syear = scheduledDate.getFullYear();
        const sday = String(scheduledDate.getDate()).padStart(2, "0");
        const smonth = scheduledDate.getMonth() + 1;
        sdate = syear + "-" + smonth + "-" + sday;
        var foundDate = this.loadSearch.filter(a => {
          return a.requestedPickupTime.substring(0, 10) === sdate;
        });
        this.loadSearch = foundDate;
      }
      if (document.getElementById("search").value !== "") {
        // find matching requested dates
        var foundName = this.loadSearch.filter(function(client) {
          return (
            client.loadName.indexOf(document.getElementById("search").value) !==
            -1
          );
        });
        this.loadSearch = foundName;
      }
      if (document.getElementById("client").value !== "") {
        // find matching client code
        var ccode = this.clientCode.ccode;
        var foundClient = this.loadSearch.filter(function(client) {
          return client.clientCode.indexOf(ccode) !== -1;
        });
        this.loadSearch = foundClient;

        var acode = this.clientCode.acode;
        // find matching account code
        var foundAccount = this.loadSearch.filter(function(client) {
          return client.accountCode.indexOf(acode) !== -1;
        });
        this.loadSearch = foundAccount;
      }
      var i = 0;
      for (i = 0; i < this.loadSearch.length; i++) {
        var statusName = "";
        statusName = this.status.find(x => x.id === this.loadSearch[i].status)
          .name;
        var ssdate = "";
        if (this.loadSearch[i].scheduledDate) {
          var scheduledDateOutput = new Date(this.loadSearch[i].scheduledDate);
          const syear = scheduledDateOutput.getFullYear();
          const sday = String(scheduledDateOutput.getDate()).padStart(2, "0");
          const smonth = scheduledDateOutput.getMonth() + 1;
          ssdate = sday + "/" + smonth + "/" + syear;
        }
        var requestDate = new Date(this.loadSearch[i].requestedPickupTime);
        const year = requestDate.getFullYear();
        const day = String(requestDate.getDate()).padStart(2, "0");
        const month = requestDate.getMonth() + 1;
        const hours = requestDate.getHours();
        const minutes = requestDate.getMinutes();
        this.results.push({
          date: ssdate,
          client:
            this.loadSearch[i].accountCode +
            ":" +
            this.loadSearch[i].clientCode +
            " (" +
            this.loadSearch[i].clientCode +
            ")",
          load: this.loadSearch[i].loadName,
          rdate: day + "/" + month + "/" + year + " " + hours + ":" + minutes,
          driver: this.loadSearch[i].driverName,
          truck: this.loadSearch[i].truckName,
          origin:
            this.loadSearch[i].pickupAddress.address +
            " " +
            this.loadSearch[i].pickupAddress.town,
          dest:
            this.loadSearch[i].destinationAddress.address +
            " " +
            this.loadSearch[i].destinationAddress.town,
          qty: this.loadSearch[i].qty,
          price: this.loadSearch[i].priceCharged,
          status: statusName,
          id: this.loadSearch[i].bookingId
        });
      }
      if (this.loadSearch.length > 0) {
        this.isEnabled = true;
        this.isNoResults = false;
      } else {
        this.isEnabled = false;
        this.isNoResults = true;
      }
    },
    reset() {
      this.results = [];
      this.clientCode = "";
      this.searchDate = null;
      this.searchName = null;
      this.isEnabled = false;
      this.isNoResults = false;
    },
    selectLoad(record) {
      this.$router.push({ name: "editJob", params: { id: record.id } });
    },
    async getJobs() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl +
            "transport?mode=app&row_type=transport_booking&orderby=day",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.loads = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClients() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "client_account/account_code_list",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.clients = data;
        // this.sortArrays()
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.getJobs();
    this.getClients();
  }
};
</script>
